<template>
  <div id="catalog-search-form">
    <catalog-search-form
      class="pl-12 pr-8"
      :search="searchTerm"
      :filters="filtersToShow"
      :selected-filters="selectedFilters"
      :loading="loading"
      :search-label="catalogSearchLabel"
      clear-button-color="accent"
      breakpoint="smAndDown"
      @show-filters="showFilters"
      @get-query-string="searchUpdated"
    />
  </div>
</template>
<script>
import { CatalogSearch as CatalogSearchForm } from '@tangocard/mango'
import {
  GET_CATALOG,
  GET_CATALOG_SEARCH_PARAMS
} from '@/store/get-types'
import { SET_CATALOG_SEARCH_PARAMS } from '@/store/action-types'
import { FulfillmentType } from '@/cowboy/EnumTypes'
import { mapGetters, mapActions } from 'vuex'
import {
  CATALOG_SEARCH_TERM_KEY,
  CATALOG_FULFILLMENT_TYPES_KEY
} from '@/components/shared/catalog/catalog-search-constants'

export default {
  name: 'CatalogSearch',
  components: {
    CatalogSearchForm
  },
  data () {
    return {
      searchTerm: null,
      filters: [
        {
          key: CATALOG_FULFILLMENT_TYPES_KEY,
          label: 'Delivery',
          options: [
            {
              label: this.$t('catalog-digital-fulfillment'),
              value: FulfillmentType.DIGITAL
            },
            {
              label: this.$t('catalog-physical-fulfillment'),
              value: FulfillmentType.PHYSICAL
            }
          ]
        }
      ],
      selectedFilters: {
        fulfillmentTypes: null
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      catalog: GET_CATALOG,
      catalogSearchParams: GET_CATALOG_SEARCH_PARAMS
    }),
    catalogHasPhysicalItems () {
      const { brands = [] } = this.catalog || {}
      return brands.filter(this.brandHasPhysicalItems).length > 0
    },
    filtersToShow () {
      return this.catalogHasPhysicalItems ? this.filters : []
    },
    catalogSearchLabel () {
      return this.$t('catalog-search-label')
    }
  },
  watch: {
    catalogSearchParams: {
      async handler (params) {
        const urlSearchParams = new URLSearchParams(params)
        this.searchTerm = urlSearchParams.get(CATALOG_SEARCH_TERM_KEY)
        this.selectedFilters.fulfillmentTypes = urlSearchParams.get(
          CATALOG_FULFILLMENT_TYPES_KEY
        )
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      setCatalogSearchParams: SET_CATALOG_SEARCH_PARAMS
    }),
    brandHasPhysicalItems (brand) {
      return brand.items.find(
        item => item.fulfillmentType === FulfillmentType.PHYSICAL
      )
    },
    showFilters (show) {
      this.$emit('show-filters', show)
    },
    searchUpdated (queryString) {
      this.loading = true
      this.setCatalogSearchParams(queryString)
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-input .v-input__slot {
  border-radius: 4px;
}
</style>
